import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

export interface ChoosePlanModalState {
  shouldShowPlanModal: boolean;
  lastTimeModalWasShown: Date | null;
  neverShowPlanModalAgain: boolean;
}

const initialState = {
  shouldShowPlanModal: false,
  lastTimeModalWasShown: null,
  neverShowPlanModalAgain: false,
} as ChoosePlanModalState;

export const choosePlanModalSlice = createSlice({
  name: 'choosePlanModalPersist',
  initialState,
  reducers: {
    setShouldShowPlanModal: (state, { payload }: PayloadAction<boolean>) => {
      state.shouldShowPlanModal = payload;
    },
    setNeverShowPlanModalAgain: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.neverShowPlanModalAgain = payload;
    },
    setLastTimeModalWasShown: (
      state,
      { payload }: PayloadAction<Date | null>,
    ) => {
      state.lastTimeModalWasShown = payload;
    },
  },
});

export const choosePlanModalState = (state: RootState) =>
  state.choosePlanModalPersist as ChoosePlanModalState;

export const {
  setShouldShowPlanModal,
  setLastTimeModalWasShown,
  setNeverShowPlanModalAgain,
} = choosePlanModalSlice.actions;

export default choosePlanModalSlice.reducer;
